import React from 'react';
import { Map as MapIcon } from 'lucide-react';
import type { LocationDef } from '#entities/location/index.js';

interface CityPageProps {
  cityName: string;
  cityDescription: string;
  streets: LocationDef[];
  onEnterStreet: (def: LocationDef) => void;
}

export const CityPage: React.FC<CityPageProps> = ({
  cityName,
  cityDescription,
  streets,
  onEnterStreet,
}) => {
  return (
    <div className="animate-in fade-in zoom-in-95 duration-500">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end mb-6 gap-2">
        <div>
          <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-muted-foreground mb-2">Глобальная сеть</h2>
          <h1 className="text-3xl font-black uppercase tracking-tighter text-foreground">{cityName}</h1>
        </div>
      </div>

      <p className="text-muted-foreground text-[11px] md:text-sm leading-relaxed mb-6 max-w-2xl border-l-2 border-primary/30 pl-3 md:pl-4 italic">
        {cityDescription}
      </p>

      <div className="grid grid-cols-2 gap-3 md:gap-6">
        {streets.map(street => (
          <div
            key={street.id}
            onClick={() => onEnterStreet(street)}
            className="group relative p-3 md:p-8 rounded-sm border border-border bg-card/60 hover:bg-card hover:border-primary/50 transition-all cursor-pointer overflow-hidden terminal-card"
          >
            {street.imageUrl && (
              <>
                <div
                  className="absolute inset-0 z-0 opacity-20 blur-[2px] scale-105 transition-transform duration-700 group-hover:scale-110 bg-cover bg-center sepia-[0.3]"
                  style={{ backgroundImage: `url(${street.imageUrl})` }}
                />
                <div className="absolute inset-0 z-0 bg-gradient-to-t from-card via-card/80 to-transparent" />
              </>
            )}
            <div className="absolute top-0 right-0 p-2 md:p-8 opacity-5 group-hover:opacity-10 group-hover:scale-110 transition-all duration-700 text-primary z-10">
              <MapIcon size={40} className="md:size-[80px]" />
            </div>
            <div className="relative z-10">
              <h3 className="text-sm md:text-2xl font-black uppercase tracking-tight text-foreground mb-1 group-hover:translate-x-1 transition-transform truncate">{street.name}</h3>
              <p className="text-muted-foreground text-[11px] md:text-sm leading-tight md:leading-relaxed line-clamp-2 md:line-clamp-none">{street.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
